import type { FC } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import Button from 'app/components/Button/ResetedButton';
import VideogameIcon from 'app/components/VideogameIcon';
import { updateTreeValue } from 'app/pages/EventsPage/utils';
import type { EventTreeValue, EventTreeChangeAction } from 'app/pages/EventsPage/types';

import style from './style.scss';

/**
 * Component use only when sidebar is collapsed
 */

interface Props {
  value: EventTreeValue;
  onChange: (value: EventTreeValue) => void;
}

const CollapsedSelector: FC<Props> = ({ value, onChange }) => {
  const [t] = useTranslation();

  const handleChange = (action: EventTreeChangeAction) => {
    const newValue = updateTreeValue(value, action);
    onChange(newValue);
  };

  const selectAll = () => {
    handleChange({ type: 'EVENT_TREE_SELECT_ALL' });
  };

  const selectVideogame = (key: number) => () => {
    handleChange({ type: 'EVENT_TREE_TOGGLE_VIDEOGAME', payload: key });
  };

  return (
    <div>
      <Button className={style.allButton} onClick={selectAll}>
        {t('events-filter-all')}
      </Button>
      {value.videogames.map(videogame => (
        <Button
          key={videogame.slug}
          className={style.videogameButton}
          disabled={videogame.series.length === 0}
          onClick={selectVideogame(videogame.key)}
        >
          <VideogameIcon
            className={classnames(style.videogameIcon, {
              [style.videogameIcon_selected]: videogame.selected
            })}
            size={37}
            slug={videogame.slug}
          />
        </Button>
      ))}
    </div>
  );
};

CollapsedSelector.displayName = 'CollapsedSelector';

export default CollapsedSelector;
